import React, { useState } from "react";
import "../styles/ContactFormWindow.css";
import { db } from "../firebase";
import yogi from "../yogi.png";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ContactFormWindow = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    gender: "",
    age: "",
    address: "",
    email: "",
    phone: "",
    medicalIssues: "",
    sessionDate: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "inquiries"), {
        ...formData,
        timestamp: serverTimestamp(),
        contacted: false, // 👈 ensures entry is uncontacted initially
      });
      setSubmitted(true);
      setFormData({
        fullName: "",
        gender: "",
        age: "",
        address: "",
        email: "",
        phone: "",
        medicalIssues: "",
        sessionDate: "",
      });
    } catch (error) {
      alert("Submission failed. Try again.");
    }
  };

  return (
    <div className="contact-window">
      <div className="contact-left">
        <h2>Get In Touch</h2>
        <p>We’ll guide you on your yoga journey.</p>
        <div className="yogi-image-container">
          <img src={yogi} alt="Yogi" className="yogi-image" />
        </div>
      </div>

      <div className="contact-right">
        {submitted ? (
          <div className="form-submitted">
            <div className="tick-icon">✔</div>
            <h3>Thank you for reaching out!</h3>
            <p>We’ll connect with you shortly to begin your yoga journey.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              name="fullName"
              placeholder="Full Name"
              onChange={handleChange}
              value={formData.fullName}
              required
            />
            <select
              name="gender"
              onChange={handleChange}
              value={formData.gender}
              required
            >
              <option value="">Select Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </select>
            <input
              name="age"
              type="number"
              placeholder="Age"
              onChange={handleChange}
              value={formData.age}
              required
            />
            <input
              name="address"
              placeholder="Address"
              onChange={handleChange}
              value={formData.address}
            />
            <input
              name="email"
              type="email"
              placeholder="Email"
              onChange={handleChange}
              value={formData.email}
            />
            <input
              name="phone"
              type="tel"
              placeholder="Phone Number"
              onChange={handleChange}
              value={formData.phone}
            />
            <textarea
              name="medicalIssues"
              placeholder="Medical Issues (if any)"
              onChange={handleChange}
              value={formData.medicalIssues}
            ></textarea>
            <select
              name="sessionDate"
              onChange={handleChange}
              value={formData.sessionDate}
              required
            >
              <option value="">Preferred Session Start Date</option>
              <option>Immediately</option>
              <option>Within 15 Days</option>
              <option>Within 1 Month</option>
            </select>
            <button type="submit">Send</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactFormWindow;
